import axios from 'axios';
import authHeader from './auth-header';
import config from '../config';

class TradeService {
  // Create new trade
  createTrade(tradeData) {
    return axios.post(config.api.trade + '/create', tradeData, {
      headers: authHeader()
    });
  }

  // Get user trades with status
  getUserTrades(userId, status = 'all') {
    return axios.get(config.api.trade + `/user/${userId}/${status}`, {
      headers: authHeader()
    });
  }

  // Update trade status
  updateTradeStatus(tradeId, status) {
    return axios.put(config.api.trade + `/${tradeId}/status`, {
      status: status
    }, {
      headers: authHeader()
    });
  }

  // Mark trade as balance updated
  markTradeBalanceUpdated(tradeId) {
    return axios.put(config.api.trade + `/${tradeId}/balance-updated`, {}, {
      headers: authHeader()
    });
  }

  // Process completed trades
  processCompletedTrades() {
    return axios.post(config.api.trade + '/process-completed', {}, {
      headers: authHeader()
    });
  }

  // Get time profit options
  getTimeProfitOptions() {
    return axios.get(config.api.trade + '/time-options', {
      headers: authHeader()
    });
  }

  // Additional methods for different status
  getPendingTrades(userId) {
    return this.getUserTrades(userId, 'pending');
  }

  getCompletedTrades(userId) {
    return this.getUserTrades(userId, 'completed');
  }
}

export default new TradeService();